import React from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import ImportListScreen from './importList';
import { Box } from '@mui/system';

const ImportRoutes = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{ padding: '8px 12px', maxWidth: '100%' }} flexDirection="column" display={'flex'} flexGrow={1}>
            <Routes>
                <Route
                    path="/"
                    element={<ImportListScreen onOpenAsset={(id: string) => navigate(`/assets/${id}/details`)} />}
                />
            </Routes>
        </Box>
    );
};

export default ImportRoutes;
